export default {
    meta: {
        createdAt: 'Created at'
    },
    download: {
        trendSummary: {
            item: 'Trend Summary',
            title: 'Download Trend Summary'
        },
        description: 'Please select your format',
        type: {
            pdf: 'PDF',
            ppt: 'PowerPoint'
        },
        action: 'Download'
    },
    content: {
        description: 'Description'
    },
    microtrends: {
        title: 'Micro-trends'
    },
    macrotrends: {
        title: 'Macro-trends'
    }
}
